import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/health-topics")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/patient/$patientId/health-topics"!</div>;
}
